import { mapState } from 'vuex'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'
import { chooseLanguage } from '@/api/sso/user'

const i18nMixin = {
  computed: {
    ...mapState({
      currentLang: state => state.app.lang
    })
  },
  methods: {
    setLang (lang, reload) {
      this.$store
        .dispatch('SetLang', lang)
        .then(() => {
          if (this.$ls.get(ACCESS_TOKEN)) {
            chooseLanguage({}).then(() => {
              const userInfo = this.$ls.get(USER_INFO)
              if (lang !== userInfo?.chooseLanguage) {
                this.$store.dispatch('GetUserInfo', { reset: true })
              }
            })
          }
        })
        // .then(async () => {
        //   if (reload) {
        //     window.location.reload(false)
        //   }
        // })
    }
  }
}

export default i18nMixin
